﻿import axios from "axios";
import { EPCSOLandingGarantieModel } from "./types/EPCSOLandingGarantieModel";
import { correctDates } from "../core/ajax/helper";

declare var _root_url: string;
function mapUrl(url: string) {
    return _root_url + url;
}

export abstract class OldLandingController {

  public static async SendGarantieCustomerData(garantieData: EPCSOLandingGarantieModel): Promise<string> {
    const result = await axios.post(mapUrl("OldLanding/SendGarantieCustomerData"), {garantieData});
    return correctDates(result.data);
  }

  public static async IsValidSeriennummer(seriennummer: string): Promise<boolean> {
    const result = await axios.post(mapUrl("OldLanding/IsValidSeriennummer"), {seriennummer});
    return correctDates(result.data);
  }

  public static async IsValidSeriennummer9er(seriennummer: string): Promise<boolean> {
    const result = await axios.post(mapUrl("OldLanding/IsValidSeriennummer9er"), {seriennummer});
    return correctDates(result.data);
  }

}
